import { emitToLogSink, type LogContext, type LogLevel } from './log-sink';

type LogFn = (message: string, context?: LogContext) => void;

export type Logger = {
  error: LogFn;
  warn: LogFn;
  info: LogFn;
  debug: LogFn;
};

// The single sanctioned bridge to the console. An observability backend
// (Sentry/Datadog/…) attaches additively via `registerLogSink`, so console
// output stays whatever it was with or without one.
const emit = (level: LogLevel, message: string, context?: LogContext): void => {
  const prefix = `[${level}]`;
  const args: unknown[] = context === undefined ? [prefix, message] : [prefix, message, context];
  // biome-ignore lint/suspicious/noConsole: this is the single sanctioned bridge to console
  console[level](...args);
  emitToLogSink(level, message, context);
};

export const logger: Logger = {
  error: (message: string, context?: LogContext) => emit('error', message, context),
  warn: (message: string, context?: LogContext) => emit('warn', message, context),
  info: (message: string, context?: LogContext) => emit('info', message, context),
  debug: (message: string, context?: LogContext) => emit('debug', message, context),
};
